<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let isHighscore = false;
    export let score = false;

    function restartClicked() {
        dispatch('restart', {

        });
    }
</script>

<div>
    <h1>Game Over</h1>
    {#if isHighscore}
    <h2>New Highscore</h2>
    {/if}
    <h3>You scored: {score}</h3>

    <button on:click={restartClicked}>Restart</button>
</div>

<style>
    div {
        position: absolute;
        left:0px;
        top:0px;
        background-color: rgba(0, 0, 0, 0.7);
        width: 100%;
        height: 120%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        color: white;
    }

    h2 {
        color:greenyellow;
        animation-name: excitedShake;
        animation-duration: 1s;
    }

    @keyframes excitedShake {
        0% {scale: 1.0}
        50% {scale: 2.0}
        100% {scale: 1.0}
    }

    button {
        background-color: rgb(42, 179, 42);
        color:white;
        border-radius: 15px;
        padding:15px;
        border:none;
    }
</style>